export default __webpack_public_path__ + "static/media/cd.606c5225.png";